import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-header-button',
  templateUrl: './header-button.component.html',
  styleUrls: ['./header-button.component.css']
})
export class HeaderButtonComponent implements OnInit {
  @Input() imagePath: string;
  @Input() name: string;
  @Input() xOffset: number = 0;
  @Input() isShowBadge: boolean = false;
  @Input() badgeCount: number = 0;
  @Output() headerButtonClick = new EventEmitter<HeaderButtonComponent>();
  @Input() isPage = true;

  isSelected: boolean = false;
  isHovered: boolean = false;

  constructor() { }

  ngOnInit(): void {

  }

  onClick() {
    this.isHovered = false;
    this.headerButtonClick.emit(this);
  }

  onMouseOver() {
    if (!this.isSelected) {
      this.isHovered = true;
    }
  }

  onMouseOut() {
    if (!this.isSelected) {
      this.isHovered = false;
    }
  }
}
